import { computed, makeObservable } from 'mobx';

import { ISharedDataItem } from '@gem/models/sharedDataModel';

import { PayloadType } from 'APP/model/message/messageModel.types';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';
import { SharedMessages } from 'STORE/SharedData/SharedMessages/SharedMessages';

import { SharedDataItem } from '../SharedDataItem/SharedDataItem';

type TSharedArticleItem = ISharedDataItem<ArticlePayload>;

export class SharedArticles extends SharedDataItem {
  constructor(messages: SharedMessages) {
    super(messages);
    makeObservable(this);
  }

  @computed
  get items(): TSharedArticleItem[] {
    const messages = this.messages.getFilteredMessages(
      (message) => message.payload.payloadType === PayloadType.Article
    );

    return messages.map((message) => ({
      id: message.clientUuid,
      messageId: message.id,
      groupId: message.groupId,
      payload: message.payload,
      serverTime: message.serverTime,
    }));
  }

  @computed
  get count(): number {
    return this._count || this.items.length;
  }
}
